import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from "./ContainerGrid"
import SecureImage from "./SecureImage"
import AuthContext from "./auth/Context";

import UploadIcon from '@mui/icons-material/Upload';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';
import CancelShareIcon from '@mui/icons-material/CancelPresentation';
import LinkIcon from '@mui/icons-material/Link';

import FileCopy from '@mui/icons-material/FileCopy';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import DescriptionIcon from '@mui/icons-material/Description';

import Dialog from './ManagedModal';
import FlexDialog from './Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FileViewer from "./FileViewer";
import ImageViewer from './ImageViewer';


import Toolbar from '@mui/material/Toolbar';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DownloadIcon from '@mui/icons-material/Download';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
const code ="file";
class ListFile extends React.Component{
    constructor(props){
        super(props);
        this.state={
            load:0,
            showDialog:0,
            code:null,
            listInfo:null,
            InputBase:null,
            viewFile:"",
            viewType:"",
            currentFile:null,
            typeView:this.props.typeView || "icon"
        }
        this.renderContent = this.renderContent.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.showDialogPicker = this.showDialogPicker.bind(this);
        this.renderItems = this.renderItems.bind(this);
        this.addLinkFile = this.addLinkFile.bind(this);
        this.search = this.search.bind(this);
        this.openViewer = this.openViewer.bind(this);
        this.closeViewer = this.closeViewer.bind(this);

    }
    shouldComponentUpdate(nextProps,nextState){
        if(nextState.load!==this.state.load 
            || nextState.showDialog!==this.state.showDialog 
            || nextState.typeView!==this.state.typeView 
            || nextState.code!==this.state.code 
            || nextProps.idLink!==this.props.idLink 
            || nextProps.idFolder!==this.props.idFolder 
            || nextProps.typeView!==this.props.typeView 
        ) return true;
        return false;
    }
    async componentDidMount() {
        const {default:InputBase} = await import(
            "./InputBase"
          );
        this.setState({
            InputBase,load:this.state.load+1
        },()=>{
            this.loadListInfo();
        })
    }
    componentDidUpdate(oldProps){
        if(oldProps.typeView!==this.props.typeView){
            this.setState({typeView:this.props.typeView});
        }
    }
    async loadListInfo(){
        this.context.setProgressStatus(true);
        try{
            let listInfo = await this.context.apis.asyncGetData(this.context.getToken(),"listinfo",{code:code.toLowerCase()},null,true);
            if(listInfo){
                this.setState({code:code,listInfo,load:this.state.load+1});
                this.context.setProgressStatus(false);
            }else{
                this.context.setProgressStatus(false);
                this.props.history.push(`/404`);
            }
        }catch(e){
            this.context.setProgressStatus(false);
        }
    }
    showDialogPicker(pickerFunc){
        this.pickerFunc = pickerFunc;
        this.setState({showDialog:1,viewFile:false,load:this.state.load+1})
    }
    closeDialogPicker(){
        if(this.pickerFunc){
            this.pickerFunc(null);
        }
        delete this.pickerFunc;
        this.setState({showDialog:0});
    }
    copy(url){
        navigator.clipboard.writeText(url);
        this.context.toast("Copied");
    }
    unshare(file){
        this.context.setProgressStatus(true);
        this.context.apis.asyncPostList(this.context.getToken(),"file",{shared:false,_id:file._id},{id_app:file.id_app}).then(()=>{
            file.shared = false;
            //console.log("unshare file",file);
            this.context.alert(this.context.apis.getLabel("Chương trình đã thực hiện xong"))
        }).catch(e=>{
            this.context.alert(e.message||e.error||e,null,"red")
        })
    }
    edit(file){
        this._list.editItem(file)
    }
    search(key){
        key  = key.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
        this._list.search({},{$or:[{"file.originalname":{$regex:key,$options:"i"}},{"mieu_ta":{$regex:key,$options:"i"}},{"text_from_image":{$regex:key,$options:"i"}}]});
    }
    share(file){
        let url = `${this.context.config.server_url}/public/file/shared/${file._id}`;
        if(file.shared) return this.context.alert(<div>
            <div style={{display:"flex",flexDirection:"row",justifyItems:"center"}}>
                <h5  style={{flexGrow:1}}>{this.context.apis.getLabel("Link file")}</h5>
                
                <IconButton size="small" onClick={()=>this.unshare(file)} style={{marginRight:10}}>
                    <Tooltip title={this.context.apis.getLabel("Bỏ chia sẻ file này")}>
                        <CancelShareIcon style={{fontSize:18}}/>
                    </Tooltip>
                </IconButton>

                <IconButton size="small" onClick={()=>this.copy(url)}>
                    <Tooltip title={this.context.apis.getLabel("Sao chép liên kết")}>
                        <FileCopy style={{fontSize:18}}/>
                    </Tooltip>
                </IconButton>
                
            </div>
            <div style={{display:"flex",flexDirection:"row",justifyItems:"center",marginTop:10,border:"1px solid #ddd",borderRadius:5,padding:10}}>
                <div contentEditable={false} style={{flexGrow:1}}>
                    {url}
                </div>
            </div>
        </div>)
        this.context.setProgressStatus(true);
        this.context.apis.asyncPostList(this.context.getToken(),"file",{shared:true,_id:file._id},{id_app:file.id_app}).then(()=>{
            file.shared = true;
            //console.log("shared file",file);
            this.context.alert(<div>
                <div style={{display:"flex",flexDirection:"row",justifyItems:"center"}}>
                    <h5  style={{flexGrow:1}}>{this.context.apis.getLabel("Link file")}</h5>
                    
                    <IconButton size="small" onClick={()=>this.unshare(file)} style={{marginRight:10}}>
                        <Tooltip title={this.context.apis.getLabel("Bỏ chia sẻ file này")}>
                            <CancelShareIcon style={{fontSize:18}}/>
                        </Tooltip>
                    </IconButton>

                    <IconButton size="small" onClick={()=>this.copy(url)}>
                        <Tooltip title={this.context.apis.getLabel("Sao chép liên kết")}>
                            <FileCopy style={{fontSize:18}}/>
                        </Tooltip>
                    </IconButton>
                    
                </div>
                <div style={{display:"flex",flexDirection:"row",justifyItems:"center",marginTop:10,border:"1px solid #ddd",borderRadius:5,padding:10}}>
                    <div contentEditable={false} readOnly style={{flexGrow:1}}>
                        {url}
                    </div>
                </div>
            </div>)
        }).catch(e=>{
            this.context.alert(e.message||e.error||e,null,"red")
        })
    }
    downloadFile(file,download=false){
        if(this.pickerFunc){
            this.pickerFunc(file);
            delete this.pickerFunc;
            this.setState({showDialog:0});
            return;
        }

        let url = `${this.context.config.server_url}/api/${this.props.idApp || this.context.config.id_app}/file/download/${file._id}?access_token=${this.context.getToken()}&size=FULL`;
        if(this.props.onClick){
            return this.props.onClick({url:url,file});
        }
        if((file.file||{}).url && !(file.file||{}).remote_id){
            return window.open((file.file||{}).url);
        }

        let type = ((file.file||{}).extension||"").toLowerCase();
        if(["png", "jpeg","jpg", "gif", "bmp","pdf","csv","xlsx","docx","mp4", "webm","mp3"].indexOf(type)>=0 && !download){
            this.setState({
                viewFile:url,typeFile:type,viewType:type,fileName:(file.file||{}).originalname || (file.file||{}).name,currentFile:file,load:this.state.load+1
            },()=>{
                this.openViewer();
            })
        }else{
            this.context.apis.downloadFile(url + "&action=download",(file.file||{}).originalname || (file.file||{}).name);
        }
        
    }
    async removeFile(file){
        this._list.deleteItem(file,()=>{
            console.log("file was deleted")
        })
    }
    renderContent(){
        if(!this.state.currentFile) return null;
        if(this.props.renderPdfContent && this.state.typeFile==="pdf"){
            return this.props.renderPdfContent({url:this.state.viewFile,file:this.state.currentFile})
        }
        if(this.props.renderContent){
            return this.props.renderContent({url:this.state.viewFile,file:this.state.currentFile});
        }
        const files = [
            { 
                name:this.state.currentFile.file?.name||"file",
                url: !(this.state.currentFile.file||{}).remote_id && this.state.currentFile.file?.url?this.state.currentFile.file?.url :this.state.viewFile,
                ext:this.state.typeFile
            },
        ];
        if (IMAGE_EXTENSIONS.includes(this.state.typeFile)) {
            return <ImageViewer
                    src={files[0].url}
                    alt={files[0].name}
                />
        }
        return (
            <FileViewer
                files={files}
                style={{ height: "100%",width:"100%" }}
            />
        );
    }
    renderIcon(file){
        if(this.props.renderIcon) return this.props.renderIcon(file);
        return <DescriptionIcon  style={{width:128,height:128}}/>
    }
    listView(rows){
        const readOnly = this.props.readOnly;
        return (
            <div  style={{width:"100%"}}>
                <List>
                    {rows.map(p => {
                        let avt;
                        let ext = (p.file || {}).extension;
                        if (ext === "png" || ext === "jpg" || ext === "jpeg" || ext === "gif") {
                            avt = `${this.context.config.server_url}/api/${this.props.idApp || this.context.config.id_app}/file/download/${p._id}?access_token=${this.context.getToken()}&size=248`;
                            let trustkey = this.context.config.trustkey;
                            if (trustkey) {
                                avt += (avt.indexOf("?") < 0 ? "?" : "&") + "trustkey=" +  encodeURIComponent(trustkey);
                            }
                        }
                        return (
                            <ListItem 
                                key={p._id} 
                                secondaryAction={
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end" }}>
                                        {!readOnly && <IconButton size="small" onClick={() => this.share(p)}>
                                            <ShareIcon sx={{ fontSize: 18 }} />
                                        </IconButton>}

                                        {!readOnly && <IconButton size="small" onClick={() => this.edit(p)} sx={{ ml: '10px' }}>
                                            <EditIcon sx={{ fontSize: 18 }} />
                                        </IconButton>}

                                        {!readOnly && <IconButton size="small" onClick={() => this.removeFile(p)} sx={{ ml: '10px' }}>
                                            <RemoveCircleIcon sx={{ fontSize: 18 }} />
                                        </IconButton>}
                                    </div>
                                }
                            >
                                <ListItemIcon 
                                    sx={{ cursor: "pointer", height: "100%" }} 
                                    onClick={() => this.downloadFile(p)}
                                >
                                    <SecureImage
                                        src={avt}
                                        sx={{ width: 48, height: 48,borderRadius:2 }}
                                        variant="rounded"
                                    >
                                        <DescriptionIcon />
                                    </SecureImage>
                                </ListItemIcon>
                            
                                <ListItemText
                                    onClick={() => this.downloadFile(p)}
                                    sx={{ 
                                        height: "100%", 
                                        cursor: "pointer",
                                        overflow: 'hidden' ,
                                        minWidth: 0,
                                        mr: !readOnly?'100px':0
                                    }}
                                    primary={(p.file || {}).originalname || (p.file || {}).name}
                                    slotProps={{
                                        primary:{ noWrap: true },
                                        secondary:{ noWrap: true, variant: 'caption' }
                                    }}
                                    secondary={`${(p.name_user_created || p.user_created).split("@")[0]}, ${Date.formatRelativeTime(p.date_created)}`}
                                />
                            </ListItem>
                        )
                    })}
                </List>
            </div>
        )
    }
    gridView(rows){
        let cardProps = {...(this.context.config.cardProps||{})}
        let cardStyle=cardProps.style||{};
        delete cardProps.style;
        const readOnly = this.props.readOnly;
        return (
            <div  style={{width:"100%"}}>
                <Grid container style={{width:"100%"}}>
                    {rows.map(p=>{
                        let avt;
                        let ext = (p.file||{}).extension;
                        if(ext==="png" || ext ==="jpg" || ext==="jpeg" || ext==="gif"){
                            avt = `${this.context.config.server_url}/api/${this.props.idApp || this.context.config.id_app}/file/download/${p._id}?access_token=${this.context.getToken()}&size=248`;
                            let trustkey = this.context.config.trustkey;
                            if (trustkey) {
                                avt += (avt.indexOf("?") < 0 ? "?" : "&") + "trustkey=" +  encodeURIComponent(trustkey);
                            }
                        }
                        return (
                            <Grid
                                key={p._id}
                                style={{padding:5}}
                                size={{
                                    lg: 3,
                                    md: 3,
                                    xs: 6,
                                    sm: 6
                                }}>
                                <Tooltip title={(p.file||{}).originalname || (p.file||{}).name}>
                                    <Card style={{height:"100%",width:"100%",position:"relative",...cardStyle}} {...cardProps}>
                                        <CardActionArea onClick={()=>this.downloadFile(p)}  style={{height:"100%"}}>
                                            <CardContent style={{display:"flex",flexDirection:"column",justifyItems:"center",alignItems:"center",height:"100%"}}>
                                                {!!avt &&<SecureImage src={avt} style={{width:128,height:128}}/>}
                                                {!avt && this.renderIcon(p)}
                                                <div style={{padding:5}}>
                                                    <Typography variant="body1" component="div" noWrap style={{fontWeight:400,textAlgin:"center"}}>{(p.file||{}).originalname || (p.file||{}).name}</Typography>
                                                    <Typography variant="body2" component="div"  style={{textAlgin:"center",fontSize:9}}  >{`Bởi ${p.user_created.split("@")[0]}@, ${Date.formatRelativeTime(p.date_created)}`}</Typography>
                                                </div>
                                            </CardContent>
                                        </CardActionArea>
                                         <div  style={{position:"absolute",right:0,top:0,display:"flex",flexDirection:"row",justifyItems:"center",justifyContent:"flex-end"}}>
                                            {!readOnly && <IconButton size="small" onClick={()=>this.share(p)}>
                                                <ShareIcon style={{fontSize:18}}/>
                                            </IconButton>}

                                            {!readOnly &&<IconButton size="small" onClick={()=>this.removeFile(p)} style={{marginLeft:10}}>
                                                <RemoveCircleIcon style={{fontSize:18}}/>
                                            </IconButton>}

                                        </div>
                                       
                                    </Card>
                                </Tooltip>
                            </Grid>
                        );
                    })}
                </Grid>
            </div>
        );
    }
    openViewer(){
        if(this.refViewer){
            this.refViewer.open();
        }
    }
    closeViewer(){
        if(this.refViewer){
            this.refViewer.close();
        }
    }
    addLinkFile(){
        this.context.prompt("Thêm liên kết file",{file_name:"",url:"",mieu_ta:""},async (data)=>{
            let f ={file:{...data}};
            f.file.name = data.file_name;
            f.mieu_ta = data.mieu_ta;

            delete f.file.mieu_ta;
            delete f.file.file_name;

            if(this.props.idLink){
                f.id_link = this.props.idLink;
            }
            if(this.props.idFolder){
                f.id_folder = this.props.idFolder;
            }
            if(this.props.shared){
                f.shared = this.props.shared;
            }
            try{
                this.context.setProgressStatus(true);
                let rs = await this.context.apis.asyncPostList(this.context.getToken(),"file",f);
                this._list.addRow(rs);
                this.context.setProgressStatus(false);
            }catch(e){
                this.context.alert(e.message || e.error ||e,"","red");
            }
        },{form_code:"filelink"})
    }
    renderItems(){
        let defaultData={};
        if(this.props.idLink){
            defaultData.id_link = this.props.idLink;
        }
        if(this.props.idFolder){
            defaultData.id_folder = this.props.idFolder;
        }
        if(this.props.shared){
            defaultData.shared = this.props.shared;
        }
        let requiredCondition = {...(this.props.condition||{}),...defaultData};
        delete requiredCondition.shared;
        //console.log({defaultCondition,defaultData});
        const {formHeaderColor,mainTextColor} = this.context.config;
        const readOnly = this.props.readOnly;
      

        return (
            <>
                <div style={{height:"100%",display:"flex",flexDirection:"column"}} className="flex-files">
                    <div style={{flex:1,overflow:"auto"}}>
                        {this.state.listInfo &&
                            <this.state.InputBase
                                fullScreen={this.props.mediaQueryMatches}
                                hideHeader={true}
                                readOnly={true}
                                listInfo={this.state.listInfo}
                                idApp={this.props.idApp}
                                code={this.state.code}
                                title={this.state.listInfo.title}
                                rowsPerPage ={this.props.limit || 20}
                                defaultData={defaultData}
                                requiredCondition={requiredCondition}
                                defaultOptionsCode="default_list_options" 
                                optionsFormCode={`${this.state.listInfo.code.toLowerCase()}_options`}
                                ref={ref=>this._list = ref}
                                isDetail={true}
                                {...this.props}
                                mediaQueryMatches={true}
                                showPagesController={true}
                                onRowsChanged={rows=>{
                                    this.setState({
                                        rows,load:this.state.load+1
                                    })
                                    if(this.props.onFilesChanged){
                                        this.props.onFilesChanged(rows)
                                    }
                                }}
                                renderItems={({rows})=>{
                                    if(this.state.typeView!=="icon"){
                                        return this.listView(rows)
                                    }else{
                                        return this.gridView(rows)
                                    }
                                }}
                                footerProps={{style:{
                                    //borderTop:"1px solid #dddddd"
                                }}}
                                extraActions={()=>readOnly?null:<>
                                    <Button color="primary"   component="label" style={{margin:10}}>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            multiple
                                            onChange={event=>{
                                                const files = event.target.files;
                                                for (let i = 0; i < files.length; i++) {
                                                    const file = files[i];
                                                    let url = this.context.config.server_url + "/api/" + this.context.config.id_app + "/file?json=1&access_token=" + this.context.getToken();
                                                    this.context.setProgressStatus(true);
                                                    let data ={...defaultData};
                                                    data.name ="file"
                                                    this.context.apis.uploadFile(url,file,(error,rs)=>{
                                                        this.context.setProgressStatus(false);
                                                        if(error) return this.context.alert(error.message);
                                                        this._list.addRow(JSON.parse(rs));
                                                    },data)
                                                }
                                            }}
                                        />
                                        <UploadIcon/> {this.context.apis.getLabel("Tải lên")}
                                    </Button>
                                    <Button color="primary"  onClick={()=>this.addLinkFile()}  component="label" style={{margin:10}}>
                                        <LinkIcon/> {this.context.apis.getLabel("Liên kết")}
                                    </Button>
                                </>}
                                
                            />
                        }
                    </div>
                    
                    
                </div>
                <FlexDialog
                    ref={ref=>this.refViewer = ref}
                    fullScreen={true}
                    disableEscapeKeyDown={false}
                    renderTitle ={()=>{
                        return <Toolbar sx={{ backgroundColor:formHeaderColor,color:mainTextColor,p:1,pt: 'max(8px,env(safe-area-inset-top)' }}>
                                <IconButton onClick={this.closeViewer} edge="start">
                                    <ArrowBackIosNewIcon fontSize="small" style={{color:mainTextColor}} />
                                </IconButton>
                                <Typography variant="h6" fontWeight="bold" noWrap sx={{ flexGrow: 1, textAlign: 'center', pr: 4 }}>
                                    {this.state.fileName}
                                </Typography>

                                {this.state.currentFile && <IconButton  edge="start"  onClick={()=>this.downloadFile(this.state.currentFile,true)}>
                                    <DownloadIcon fontSize="small" style={{color:mainTextColor}} />
                                </IconButton>}
                            </Toolbar>
                    }}
                >
                    <DialogContent sx={{overflow:"hidden",p:0}}>
                        {this.renderContent()}
                    </DialogContent>
                </FlexDialog>
            </>
        );
    }
    render(){
        const {formHeaderColor,mainTextColor} = this.context.config;
        return (
            <>
                {this.props.isDialogPicker?
                    <Dialog
                        type="dialog"
                        fullScreen={this.context.config.isMobile}
                        fullWidth={true}
                        maxWidth={"lg"}
                        open={this.state.showDialog==1}
                        onClose={()=>this.closeDialogPicker()}
                        disableEscapeKeyDown={false}>
                        <DialogTitle sx={{backgroundColor:formHeaderColor,color:mainTextColor,p:1,pt: 'max(8px,env(safe-area-inset-top))'}}>
                            <div style={{display:"flex",flexDirection:"row",alignItems:"center",padding:0}}>
                                <Typography variant="h5" style={{flex:1}}>Chọn tệp</Typography>
                            </div>
                            
                        </DialogTitle>
                        <DialogContent sx={{p:0}}>
                            {this.renderItems()}
                        </DialogContent>
                    </Dialog>
                    :
                    <div style={{height:"100%",flex:1,overflow:"hidden"}}>
                        {this.renderItems()}
                    </div>
                    
                }
            </>
        );
    }
}
ListFile.contextType = AuthContext;
ListFile.propTypes={
  match: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any,
  idLink:PropTypes.string,
  idFolder:PropTypes.string,
  idApp:PropTypes.string,
  limit:PropTypes.number,
  condition:PropTypes.any,
  typeView: PropTypes.oneOf(["list","icon"]),
  viewFullScreen: PropTypes.bool,

  onFilesChanged:PropTypes.func,


  onClick:PropTypes.func,
  renderPdfContent:PropTypes.func,
  renderContent:PropTypes.func,
  renderIcon:PropTypes.func,
  mediaQueryMatches: PropTypes.bool,
  isDialogPicker: PropTypes.bool,
  readOnly: PropTypes.bool,
  shared: PropTypes.bool,
}
export default  ListFile;
